export class CustomDoc {
	public language: string;
	public iconTitle: string;
	public docTitle: string;
	public iconTarget: string;
	public isVisible: boolean;
	public isMandatory: boolean;
	public isPrintable: boolean;
	public geoLocation: string;
}
